import { Component, Input } from '@angular/core';

@Component({
  selector: 'apc-send-details-question-modal',
  templateUrl: './send-details-question-modal.component.html',
  styleUrls: ['./send-details-question-modal.component.scss']
})
export class SendDetailsQuestionModalComponent {
  @Input() modalRef: any;
  @Input() question: string = "";

  close(res: boolean) {
    this.modalRef.dismiss(res);
  }
}
